jQuery( document ).ready(function($) {
  // Mobile menu
  $('.menu-trigger').click(function(){
    $('.menu').toggleClass('active')
    $(this).toggleClass('active')
  })
});